import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { defaultCuttingHeightModalRecord } from './data/SetCuttingHeightRecord';

const cuttingHeightModalSlice = createSlice({
  name: 'cuttingHeightModal',
  initialState: defaultCuttingHeightModalRecord,
  reducers: {
    openCuttingHeightModal: (state, action: PayloadAction<{ selectedMissionId?: number }>) => {
      state.isOpen = true;
      if (action?.payload?.selectedMissionId !== undefined) {
        // selectedMissionId is optional and it could be 0 is case of My lawn
        state.selectedMissionId = action.payload.selectedMissionId;
      }
    },
    closeCuttingHeightModal: (state) => {
      state.isOpen = false;
    },
    setCurrentMissionId: (state, action: PayloadAction<number | string | null>) => {
      state.currentMissionId = action.payload;
    },
    setSelectedMissionId: (state, action: PayloadAction<number | null | undefined>) => {
      state.selectedMissionId = action.payload;
    },
    resetModal: () => {
      return defaultCuttingHeightModalRecord;
    },
  },
});

// Export actions
export const {
  openCuttingHeightModal,
  closeCuttingHeightModal,
  setCurrentMissionId,
  setSelectedMissionId,
  resetModal,
} = cuttingHeightModalSlice.actions;

// Export reducer
export default cuttingHeightModalSlice.reducer;
